module.exports = __webpack_public_path__ + "static/conferences-cover-6076bc0d66c4efad1c5fdd889dd32103.png";